/**
 * Front end logging util, if Raven is setup, send the error to Sentry
 * @param {Object} ex Error object
 * @param {String} level The log level ('info', 'warning', or 'error') associated with this event. Default: error
 * @param {Object} context Arbitrary data to associate with the event.
 */
export const logException = (ex, level, context) => {
    if (typeof window === 'undefined') { return; }

    // We need to make sure that ex is actually an error otherwise sentry will throw an error
    if (window.Raven && window.Raven.isSetup() && ex instanceof Error) {
        /* eslint-disable no-param-reassign */
        level = level || 'error';
        context = context || {};
        /* eslint-enable no-param-reassign */
        window.Raven.captureException(ex, {
            level,
            extra: context
        });
    }
    // eslint-disable-next-line no-console, no-unused-expressions
    window.console && console.error && console.error(ex);
};
